const { Resource } = require("./resource.js");


class ResourceGroup {
    constructor(simulator, resourceParams, startAmount) {
        this.simulator = simulator;
        this.name = resourceParams.name;
        this.alternateName = null;
        this.alternateNameToBeTrained = null;
        this.remTrainHours = null;
        this.id = resourceParams.id;
        this.maxAmount = resourceParams.maxAmount;

        this.trainingCost = 0;
        this.createInitialResources(startAmount);
    }

    createInitialResources(startAmount) {
        this.resources = []
        this.resourcesDict = {}
        for (var i = 0; i < this.maxAmount; i++) {
            var currResourceParams = { resourceName: this.name, id: this.id, isActive: i < startAmount, name: this.id + i.toString(), index: i }
            const currResource = new Resource(this.simulator, currResourceParams)

            this.resources.push(currResource);
            this.resourcesDict[currResource.name] = currResource;
        }
    }

    //Update the hours for hiring / firing / training
    updateHours() {
        this.resources.forEach(currResource => {
            currResource.updateHours();
        })

        if (this.remTrainHours == null) {
            return;
        }

        this.remTrainHours -= 1;


        if (this.remTrainHours <= 0) {
            this.finishTraining();
        }
    }

    trainResource(alternateNameToBeTrained) {
        this.alternateName = null;

        this.resources.forEach(currResource => {
            currResource.resourceTypes = [currResource.resourceTypes[0]];
        })

        this.alternateNameToBeTrained = alternateNameToBeTrained;
        var params = this.simulator.params;

        this.remTrainHours = params.trainTime;

        this.simulator.passedEvents.push({type: "startTrain", groupName: this.name, hour: this.simulator.hoursPassed, alternateGroupName: alternateNameToBeTrained})
    }

    finishTraining() {
        this.alternateName = this.alternateNameToBeTrained;
        this.alternateNameToBeTrained = null;

        this.resources.forEach(currResource => {
            currResource.resourceTypes.push(this.alternateName);
        })
        
        this.trainingCost += this.simulator.params.trainCost
        this.remTrainHours = null;

        this.simulator.passedEvents.push({type: "finishTrain", groupName: this.name, hour: this.simulator.hoursPassed, alternateGroupName: this.alternateName })
    }

    hireResource() {
        for (var i = 0; i < 3; i++) {
            var currResource = this.resources[i];

            //First check if we can remove the firing status of a person
            if (currResource.isActive && currResource.remFireHours != null) {
                currResource.cancelFireProcess();
                return "cancelledFire";
            }

            //Otherwise hire a resource
            if (!currResource.isActive && currResource.remHireHours == null) {
                currResource.startHireProcess();
                return "startedHire";
            }
        }
        return "noHire";
    }

    fireResource() {
        //Remove them in order
        for (var i = 2; i >= 1; i--) {
            var currResource = this.resources[i];

            //First check if we can remove the hiring status of a person
            if (!currResource.isActive && currResource.remHireHours != null) {
                currResource.cancelHireProcess();
                return "cancelledHire";
            }

            //Otherwise fire a person
            if (currResource.isActive && currResource.remFireHours == null) {
                currResource.startFireProcess();
                return "startedFire";
            }
        }
        return "noFire";
    }
}


module.exports = { ResourceGroup };
